import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

import FavIcon from '../app/FavIcon';

class SelectClubKNVB extends Component {
  componentDidMount() {
    document.title = `Lid worden bij de ${this.props.unionid}`;
  }

  redirect() {
    setTimeout(function () {
       window.location.href = "https://www.knvb.nl/doe-mee/lid-worden/vind-club";
    }, 4000);

  }

  render() {
    const unionIdLower = this.props.unionid.toLowerCase();

    return (

      <div className="App ">
        <FavIcon isKNVB={true} />

        <Container fluid={true}>
          <Row className="Header">
            <div className="mx-auto" id="union-logo">
              <img className="UnionLogoClubList img-fluid  float-md-center" src={`/img/${unionIdLower}logo.png`} alt={"logo " + this.props.unionid} />
            </div>
          </Row>

          <Row>
            <Container className="Content ContentWhite">
              <Row>
                 <Col md={{ size: 8,offset: 2 }}>
                   <p>Je wordt binnen enkele seconden doorgestuurd naar <a href="https://www.knvb.nl/doe-mee/lid-worden/vind-club">KNVB.nl</a>
                   </p>
                   {this.redirect()}

                 </Col>
              </Row>
            </Container>
          </Row>
          <Row>
            <div className="ml-auto">
              <img className="sl-logo" src="/img/sportlink_logo.png" alt="Sportlink logo" />
            </div>
          </Row>

        </Container>
      </div>)
    }
}
export default SelectClubKNVB;



// WEBPACK FOOTER //
// ./src/club/SelectClubKNVB.jsx